import React, { useEffect, useState } from "react";
import DetailLayout from "../../../components/DetailLayout";
import Header from "./components/Header";
import style from "./index.module.scss";
import ExerciseBar from "../ExerciseBar";
import StaticBar from "../StaticBar";
import { Button } from "antd";
import { AiOutlineLeftCircle, AiOutlineRightCircle } from "react-icons/ai";
import {
    ExerciseProps,
    PaperProps,
    TopicsItem
} from "../../../../../API/exercise";
import PageRadioDetail from "./components/PageRadioDetail";
import PageCheckBoxDetail from "./components/PageCheckBoxDetail";
import PageJudgeDetail from "./components/PageJudgeDetail";
import PageSubjectiveDetail from "./components/PageSubjectiveDetail";
import PageGapFillingDetail from "./components/PageGapFillingDetail";
import PageReadingDetail from "./components/PageReadingDetail";

interface DetailPCProps {
    data: PaperProps;
    headerData: ExerciseProps;
}

export default function ExerciseDetailPC({ data, headerData }: DetailPCProps) {
    const [checked, setChecked] = useState(1); //当前选中
    const [currentData, setCurrentData] = useState<TopicsItem>(); //选中的试题对象

    useEffect(() => {
        if (data) {
            setCurrentData(
                data.topics.find((item, index) => index + 1 === checked)
            );
        }
    }, [data, checked]);

    return (
        <DetailLayout breadcrumb="练习详情">
            <Header headerData={headerData} />

            <div className={style.header}>
                <StaticBar
                    topicCount={data.topicCount}
                    totalScore={data.totalScore}
                    teacherFinishMark={data.teacherFinishMark}
                    stuDoFlg={data.stuDoFlg}
                    stuPaperScore={data.stuPaperScore}
                    viewPaper={data.viewPaper}
                />
            </div>

            <div className={style.main}>
                <div className={style.left}>
                    {data && (
                        <ExerciseBar
                            checked={checked}
                            data={data.topics}
                            onChange={(val: number) => setChecked(val)}
                        />
                    )}
                </div>

                <div className={style.right}>
                    {currentData &&
                        currentData.queTypeId == "1" &&
                        checked === currentData.index && (
                            <PageRadioDetail
                                stuDoFlg={data.stuDoFlg}
                                data={currentData}
                            />
                        )}
                    {currentData &&
                        currentData.queTypeId == "2" &&
                        checked === currentData.index && (
                            <PageCheckBoxDetail
                                stuDoFlg={data.stuDoFlg}
                                data={currentData}
                            />
                        )}
                    {currentData &&
                        currentData.queTypeId == "3" &&
                        checked === currentData.index && (
                            <PageJudgeDetail
                                stuDoFlg={data.stuDoFlg}
                                data={currentData}
                            />
                        )}
                    {currentData &&
                        currentData.queTypeId == "4" &&
                        checked === currentData.index && (
                            <PageSubjectiveDetail
                                stuDoFlg={data.stuDoFlg}
                                data={currentData}
                                viewPaper={data.viewPaper}
                            />
                        )}
                    {currentData &&
                        currentData.queTypeId == "5" &&
                        checked === currentData.index && (
                            <PageGapFillingDetail
                                stuDoFlg={data.stuDoFlg}
                                data={currentData}
                            />
                        )}
                    {currentData &&
                        currentData.queTypeId >= "6" &&
                        checked === currentData.index && (
                            <PageReadingDetail
                                stuDoFlg={data.stuDoFlg}
                                data={currentData}
                                viewPaper={data.viewPaper}
                            />
                        )}

                    <div className={style.footer}>
                        {currentData && currentData.index !== 1 && (
                            <Button
                                className={style.prev}
                                onClick={() =>
                                    setChecked(currentData.index - 1 || 1)
                                }>
                                <AiOutlineLeftCircle />
                                上一题
                            </Button>
                        )}
                        {currentData &&
                            data &&
                            currentData.index !== data.topics.length && (
                                <Button
                                    className={style.next}
                                    onClick={() =>
                                        setChecked(currentData.index + 1 || 1)
                                    }>
                                    下一题
                                    <AiOutlineRightCircle />
                                </Button>
                            )}
                        {currentData &&
                            data &&
                            currentData.index === data.topics.length && (
                                <div className={style.lastDiv}>
                                    已是最后一题了
                                </div>
                            )}
                    </div>
                </div>
            </div>
        </DetailLayout>
    );
}
